// src/utils/inventory/getFilteredTransferActions.ts

import { InventoryTransferTableDTO } from "../../../../types/inventory/transfer/InventoryTransferTypes";

export interface TransferAction {
  label: string;
  icon?: string;
  color?: 'primary' | 'danger' | 'success' | 'secondary' | 'warning' | 'dark' | 'info';
  onClick: (row: InventoryTransferTableDTO) => void;
}

export const getFilteredTransferActions = (
  row: InventoryTransferTableDTO,
  deps: {
    hasRole: (role: string) => boolean;
    handlerGetTransferById: (id: number) => void;
    handlerOpen: (id: number, type: string) => void;
  }
): TransferAction[] => {
  const { hasRole, handlerGetTransferById, handlerOpen } = deps;

  const actions: TransferAction[] = [];

  // 👁 Todos pueden ver el detalle
  actions.push({
    label: "Ver Detalle",
    icon: "eye",
    color: "secondary",
    onClick: () => handlerGetTransferById(row.id),
  });

  // ============================================================
  // ✏ SOLO ADMIN y SUPPORT pueden EDITAR
  // ============================================================
  if (hasRole("ADMIN") || hasRole("SUPPORT")) {
    actions.push({
      label: "Editar",
      icon: "edit",
      color: "primary",
      onClick: () => handlerOpen(row.id, "edit"),
    });
  }

  // ============================================================
  // 🚫 CANCELAR disponible para USER / CASHIER / ADMIN / SUPPORT
  // ============================================================
  if (
    hasRole("USER") ||
    hasRole("CASHIER") ||
    hasRole("ADMIN") ||
    hasRole("SUPPORT")
  ) {
    actions.push({
      label: "Cancelar",
      icon: "cancel",
      color: "warning",
      onClick: () => handlerOpen(row.id, "cancel"),
    });

    // ⭐ USER y CASHIER también pueden aprobar
    actions.push({
      label: "Aprobar",
      icon: "check-circle",
      color: "success",
      onClick: () => handlerOpen(row.id, "approve"),
    });
  }

  // ============================================================
  // 🛡 SOLO ADMIN o SUPPORT → Confirmar, Rechazar y Revertir
  // ============================================================
  if (hasRole("ADMIN") || hasRole("SUPPORT")) {
    actions.push(
      {
        label: "Confirmar",
        icon: "finishFlag",
        color: "info",
        onClick: () => handlerOpen(row.id, "confirm"),
      },
      {
        label: "Rechazar",
        icon: "x-circle",
        color: "danger",
        onClick: () => handlerOpen(row.id, "reject"),
      },
    );
  }

  return actions;
};
